module.exports = __webpack_public_path__ + "static/media/ppt.5148e75b.svg";